import React from "react";

import styles from './LabelType.module.scss'

const LabelType = props => {
  
  const {children, className, colorcheme, ...other} = props
  return(
    <label className={`${styles.LabelType} ${className ? className : ''}`} {...other}>
      {children}
    </label>
  )
}

export default LabelType 